import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { AuthService } from '../services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  
  constructor(
    private authService: AuthService,
    private router: Router,
    private snackBar: MatSnackBar,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.checkAdminAccess();
  }

  private checkAdminAccess(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      try {
        const adminToken = localStorage.getItem('adminToken');
        const username = localStorage.getItem('username');
        const currentUser = localStorage.getItem('currentUser');
        
        // Check authentication through service
        const isAdmin = this.authService.isAdmin();
        const isAuthenticated = this.authService.isAuthenticated();
        
        // Allow access if any admin authentication method is valid
        if (adminToken || isAdmin || isAuthenticated || username === 'admin') {
          // Additional role check if currentUser exists
          if (currentUser) {
            try {
              const userObj = JSON.parse(currentUser);
              if (userObj.role && userObj.role !== 'admin' && username !== 'admin') {
                this.denyAccess();
                return false;
              }
            } catch (e) {
              // If parsing fails, continue with other checks
            }
          }
          return true;
        }
        
        this.denyAccess();
        return false;
        
      } catch (error) {
        console.error('Admin guard error:', error);
        this.denyAccess();
        return false;
      }
    }
    
    // Server-side check
    if (this.authService.isAdmin()) {
      return true;
    }
    
    this.denyAccess();
    return false;
  }

  private denyAccess(): void {
    this.snackBar.open('Access denied. Please login as admin.', 'Close', {
      duration: 3000,
      panelClass: ['error-snackbar']
    });
    
    this.router.navigate(['/']);
  }
}